import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatApiError, setAuthToken } from "@/lib/api";
import { useAdminManifest } from "@/lib/useAdminManifest";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Activity, LogIn } from "lucide-react";

export default function AdminLogin() {
  useAdminManifest();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      if (data?.token) setAuthToken(data.token);
      toast.success("Benvenuto");
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center px-5">
      <div className="w-full max-w-md card-soft p-8 fade-up">
        <div className="flex items-center gap-2 mb-6">
          <span className="h-10 w-10 rounded-xl bg-[#2D4A3E] text-white grid place-items-center"><Activity size={18}/></span>
          <div>
            <div className="font-display text-lg text-[#1A231F]">Studio Milano</div>
            <div className="text-xs text-[#5C7066]">Area riservata</div>
          </div>
        </div>
        <h1 className="font-display text-2xl text-[#1A231F]">Accedi al pannello</h1>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <div>
            <Label htmlFor="email">Email</Label>
            <Input id="email" data-testid="admin-email" type="email" autoComplete="username" required value={email} onChange={(e)=>setEmail(e.target.value)} className="h-12 mt-1 rounded-xl bg-white" />
          </div>
          <div>
            <Label htmlFor="pw">Password</Label>
            <Input id="pw" data-testid="admin-password" type="password" autoComplete="current-password" required value={password} onChange={(e)=>setPassword(e.target.value)} className="h-12 mt-1 rounded-xl bg-white" />
          </div>
          <Button type="submit" data-testid="admin-login-btn" disabled={loading} className="h-12 w-full rounded-xl bg-[#2D4A3E] hover:bg-[#1A2F26] text-white">
            <LogIn size={16} className="mr-2"/> {loading ? "Accesso…" : "Accedi"}
          </Button>
        </form>
      </div>
    </div>
  );
}
